import { HttpClient } from '@angular/common/http';
import { HttpService } from './http.service';


export function httpServiceFactory(http: HttpClient) {
    return new HttpService(http);
}
